import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import Icon from "../../../../components/selfcare/Icon.tsx";
import ComparingChart from "../../../../components/help/ComparingChart.tsx";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";
import IconCross from "../../../../components/icons/IconCross.tsx";
import IconCheck from "../../../../components/icons/IconCheck.tsx";

export default function IPAddressArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er en IP-adresse?</h2>
                        <p>
                            En IP-adresse er en adresse/kode, der identificerer en enhed på internettet eller i et lokalt netværk.
                            IP står for &ldquo;Internet Protocol&rdquo; og er et sæt &ldquo;regler&rdquo;, der bestemmer formatet for data, som sendes via internettet eller dit lokale netværk.
                            Har du flere enheder koblet på dit wifi, så går alle enheder under samme IP-adresse.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Din IP-adresse hos Hiper</h2>
                        <p>
                            Som standard løsning hos os får din internetforbindelse en privat IP-adresse via CGNAT (Carrier-Grade Network Address Translation).
                            CGNAT er &ldquo;skal&rdquo;, som beskytter din forbindelse fra det offentlige netværk.
                            CGNAT gør det muligt at udvide netværk, selvom der er mangel på IPv4-adresser.
                            Oftest er en standard IP-adresse ganske fin, men i enkelte tilfælde kan det være nødvendigt at have en offentlig IP.
                            Det kan det f.eks. være ved online gaming eller fjernadgang til enheder (f.eks. hvis du hoster din egen server), og i nogle tilfælde ved ældre <Link to={'/hjaelp/internet-og-wifi/vpn-og-subnet'}>VPN-typer</Link>.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <h2>Hvilken offentlig IP-adresse kan jeg få?</h2>
                    <ComparingChart className={'comparing-chart--ip-address'}>
                        <thead>
                            <tr>
                                <th></th>
                                <th><p>Fast offentlig IP</p></th>
                                <th><p>Dynamisk offentlig IP</p></th>
                                <th><p>Privat IPv4</p></th>
                                <th><p>IPv6</p></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th><p>Fibernet & internet via telefonstikket</p></th>
                                <td><Icon component={IconCheck}/></td>
                                <td><Icon component={IconCheck}/></td>
                                <td><Icon component={IconCheck}/></td>
                                <td>
                                    <Icon component={IconCheck}/>
                                    <p>
                                        Vi tilbyder et fast /128 WAN og et fast /48 eller /56 præfiks.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>5G-internet</p></th>
                                <td><Icon component={IconCross}/></td>
                                <td><Icon component={IconCross}/></td>
                                <td><Icon component={IconCheck}/></td>
                                <td><Icon component={IconCross}/></td>
                            </tr>
                            <tr>
                                <th><p>Internet via kabel-tv-stikket</p></th>
                                <td><Icon component={IconCross}/></td>
                                <td><Icon component={IconCheck}/></td>
                                <td><Icon component={IconCheck}/></td>
                                <td><Icon component={IconCross}/></td>
                            </tr>
                        </tbody>
                    </ComparingChart>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan kan jeg få IPv6?</h2>
                        <p>
                            Vi sigter altid efter at fremtidssikre vores netværk, så du bliver automatisk tildelt en IPv6-adresse med et tilhørende præfiks via DHCPv6, hvis du har <Link
                            to={Routing.Broadband.Fiber}
                        >fibernet</Link>.
                            På <Link to={Routing.Broadband.Coax}>internet via kabel-tv-stikket</Link> er IPv6 desværre ikke muligt.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er forskellen på IPv4 og IPv6?</h2>
                        <p>
                            IPv4 (Internet Protocol version 4) og IPv6 (Internet Protocol version 6) er begge versioner af Internetprotokollen (IP).
                        </p>
                        <p>
                            IPv4-adresser består af 32 bit og skrives som fire tal adskilt af prikker, for eksempel <code className="inline-code">192.168.1.1</code>.
                            Den begrænsede adresseplads på cirka 4,3 milliarder adresser har ført til en udbredt brug af teknologier som NAT (Network Address Translation) for at udvide rækkevidden.
                        </p>
                        <p>
                            IPv6-adresser består af 128 bit og skrives som otte grupper af fire hexadecimale tal adskilt af kolon, for eksempel <code
                            className="inline-code"
                        >2001:0000:130F:0000:0000:09C0:876A:130B</code>.
                            IPv6 har et langt større adresseområde, hvilket løser problemet med manglen på IP-adresser.
                            Med sin enorme adresseplads er NAT derfor unødvendig, da hver enhed kan have en global unik IP-adresse.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvor mange IP-adresser kan jeg få?</h2>
                        <p>
                            Du kan få én IP-adresse tilknyttet din forbindelse.
                        </p>
                    </div>
                </div>

                <div className="article article--connect">
                    <h2>Hvad er forskellen på en fast og dynamisk IP-adresse?</h2>
                    <div className="paragraph">
                        <p>
                            Du kan kun få en fast eller dynamisk IP-adresse, hvis du har en offentlig IP-adresse.
                        </p>
                        <p>
                            En dynamisk IP-adresse vil skifte, hver gang din router har været slukket eller genstartes.
                            Når din router tændes igen, bliver den tildelt den første ledige IP-adresse.
                        </p>
                        <p>
                            En fast IP-adresse er forbeholdt dit netværk og skifter derfor ikke, selvom din router har været slukket i længere tid.
                        </p>
                    </div>
                </div>
                <div className="article article--2">
                    <div className={'text-box text-box--match-height text-box--teal'}>
                        <div className="paragraph">
                            <h3>Fast IP</h3>
                            <ul className="list list--bullet list--compact">
                                <li>Koster 19 kr./md.</li>
                                <li>Konstant fast</li>
                                <li>God til overvågningskamera og hjemmenetværk</li>
                                <li>Sikrer adgang til din server</li>
                                <li>Ændrer din NAT-type til NAT&nbsp;2</li>
                                <li>Tildeles dynamisk</li>
                                <li>Du skal ikke selv indtaste IP-adresse, subnet maske eller gateway</li>
                                <li>God til gaming</li>
                            </ul>
                        </div>
                    </div>
                    <div className={'text-box text-box--match-height text-box--teal'}>
                        <div className="paragraph">
                            <h3>Dynamisk IP</h3>
                            <ul className="list list--bullet list--compact">
                                <li>Gratis</li>
                                <li>Skifter hvis routeren er slukket i længere tid</li>
                                <li>Ændrer din NAT-type til NAT&nbsp;2</li>
                                <li>Tildeles dynamisk</li>
                                <li>God til gaming</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad koster en IP-adresse?</h2>
                        <p>
                            En dynamisk IP-adresse er gratis og en fast IP-adresse koster 19 kr./md.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan får jeg en fast eller dynamisk IP?</h2>
                        <p>
                            Hvis du ønsker at få tilkoblet en IP-adresse på din forbindelse, så skal du kontakte vores support.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er min IP-adresse?</h2>
                        <p>
                            Hvis du har en privat IP-adresse, er det nemmeste, hvis du ringer til os, og så vi kan tjekke den for dig.
                            Hvis du har en offentlig IP-adresse, kan du tjekke din IP-adresse her: <a
                                href={'https://whatismyipaddress.com/'}
                                target={'_blank'}
                                rel={'nofollow noreferrer noopener'}
                            >whatismyipaddress.com</a>.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er DNS og A-record?</h2>
                        <p>
                            DNS står for Domain Name System og oversætter hjemmesidens IP-adresse for dig, så du kun behøver at skrive navnet på en hjemmeside i din søge browser.
                            Alle hjemmesider på internettet har sin egen unikke kode kaldet en IP-adresse.
                            For at gøre det lettere for dig at finde hjemmesider, spilservere mm., får IP-adresserne tildelt et &ldquo;hjemmesidenavn&rdquo;.
                        </p>
                        <p>
                            En A-record (Address Record) er en type DNS-record, der bruges til at foretage et DNS-lookup.
                        </p>
                        <p>
                            En DNS-server er den enhed eller software, der udfører disse opslag og oversætter domænenavne til IP-adresser.
                            Denne proces kaldes også for et DNS lookup. DNS-servere er vigtige for at sikre, at du hurtigt kan finde og få adgang til de rigtige websider eller tjenester, når du bruger internettet.
                        </p>
                        <p>
                            Vi bruger Googles DNS som vores primære DNS og Cloudflares som vores sekundære DNS.
                        </p>
                        <p>
                            <strong>Primær DNS:</strong> <code className="inline-code">8.8.8.8</code><br/>
                            <strong>Sekundær DNS:</strong> <code className="inline-code">1.1.1.1</code>
                        </p>
                        <p>
                            Den primære DNS-server er den første server, der kontaktes for DNS-lookups.
                            Den sekundære DNS-server er en backup-server, der bruges, hvis den primære DNS-server ikke er tilgængelig.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Reverse DNS og PTR Record</h2>
                        <p>
                            DNS hjælper med at oversætte et hjemmesidenavn, også kaldet et domæne til en IP-adresse.
                            En Reverse DNS gør det modsatte, nemlig oversætter IP-adressen, som du har modtaget fra os til et domænenavn.
                        </p>
                        <p>
                            En PTR-record (Pointer Record) er en type DNS-record, der bruges til at foretage et reverse DNS-lookup.
                        </p>
                        <p>
                            Hvis du tilkøber en fast offentlig IP til din forbindelse, så kan vi sætte en PTR Record til.
                            Systemet opdateres med PTR records hver dag kl. 03:00 og når alt er gennemgået af Google og Cloudflares systemer, så virker det.
                            Det tager omkring en til to timer.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er en gateway?</h2>
                        <p>
                            En gateway er en enhed, der fungerer som et adgangspunkt mellem et lokalt netværk (LAN) og internettet.
                            Den spiller en afgørende rolle i at muliggøre kommunikation mellem enheder i det lokale netværk og eksterne ressourcer på internettet.
                            Eksempler på gateways kunne f.eks. være en router eller et modem.
                        </p>
                        <p>
                            Gateways kan også fungere som DNS-servere.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "installationsmanual",
                        "name": "Sådan installerer du din router"
                    },
                    {
                        "category": "udstyr",
                        "article": "kan-jeg-bruge-mit-eget-udstyr",
                        "name": "Kan jeg bruge mit eget udstyr?"
                    },
                    {
                        "category": "udstyr",
                        "article": "bridge-mode",
                        "name": "Bridge mode"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "hastighedstest",
                        "name": "Hastighedstest"
                    }
                ]}
            />
        </>
    )
}
